// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-input .placeholder{color:rgba(105,110,117,.5)}.select-input .search-box .select-input-search input{border:none !important;height:41px}.select-input .select-options-list{margin-top:-8px;max-height:300px;overflow:auto;position:static}", ""]);
// Exports
module.exports = exports;
